<section>
  <div class="container-style">
    <form novalidate [formGroup]="formValueDistribute" class="mb-2 py-1 px-2">
      <div class="row">
        <div class="col-lg-112 col-md-12 col-sm-12 col-12">
          <app-custom-input-decimal formControlName="totalValueDistribute" [labelText]="'Valor a Distribuir'"
            [required]="true"></app-custom-input-decimal>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-2 col-12 d-flex justify-content-end mt-3">
          <app-custom-button [label]="'Actualizar'" [severity]="'primary'" [variant]="undefined" [width]="'5rem'"
            (onClick)="totalValueDistribute()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>